@if (addressData) {
  <h5 class="re-mb-30">{{ 'summary.address.titleDelivery' | translate }}</h5>
  <div class="re-summary-row">
    <div>{{ 'address.postCode.postCodeAndCity' | translate }}</div>
    <div>{{ addressData.postCode }}, {{ addressData.cityName }}</div>
  </div>
  <div class="re-summary-row">
    <div>{{ 'address.street.title' | translate }}</div>
    <div>{{ addressData.streetName }}</div>
  </div>
  <div class="re-summary-row">
    <div>{{ 'address.housenumber.title' | translate }}</div>
    <div>{{ addressData.houseNum }}</div>
  </div>
}
